import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ebdbe76"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-header sb-budget"
};
const _hoisted_2 = {
  class: "ba-row"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-left-side"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "total ba-text ba-text-small ba-text-lighter"
}, "Total →")], -1));
const _hoisted_4 = {
  class: "ba-right-side"
};
const _hoisted_5 = {
  class: "ba-perfomance ba-perfomance-top"
};
const _hoisted_6 = {
  class: "total-amount ba-text ba-text-purple"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "110px",
    "height": "36px"
  }
}, null, -1));
const _hoisted_8 = {
  class: "total-variation-and-last-week-spend ba-text ba-text-right"
};
const _hoisted_9 = {
  key: 1,
  class: "ba-double-content",
  style: {
    "padding": "0px 4px",
    "gap": "0px",
    "color": "#93999F !important"
  }
};
const _hoisted_10 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "gap": "3px",
    "align-items": "center"
  }
};
const _hoisted_11 = {
  class: "ba-double-content-inner",
  style: {
    "color": "unset !important",
    "flex-direction": "column"
  }
};
const _hoisted_12 = {
  class: "ba-row"
};
const _hoisted_13 = {
  class: "ba-left-side"
};
const _hoisted_14 = {
  class: "ba-product-info top"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-product-info-block state"
}, null, -1));
const _hoisted_16 = {
  class: "ba-product-info-groups"
};
const _hoisted_17 = {
  class: "search-box"
};
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"ba-product-info-prioritized\" data-v-7ebdbe76><div style=\"width:50%;border-right:solid 1px #E3E3E3;\" data-v-7ebdbe76></div><div style=\"width:50%;\" data-v-7ebdbe76><div class=\"badge-box\" data-v-7ebdbe76><div class=\"badge ba-text ba-text-small\" data-v-7ebdbe76>Prioritized by</div></div></div></div>", 1);
const _hoisted_19 = {
  class: "ba-product-data ba-product-data-middle"
};
const _hoisted_20 = {
  class: "ba-product-data-content"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "switch-box"
}, null, -1));
const _hoisted_22 = {
  class: "switch-box"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-right-side"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "ba-perfomance ba-perfomance-middle"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "ba-perfomance-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "ba-column-title ba-text"
}, "Budget Settings")])])], -1));
const _hoisted_24 = {
  class: "ba-row"
};
const _hoisted_25 = {
  class: "ba-left-side"
};
const _hoisted_26 = {
  class: "ba-product-info"
};
const _hoisted_27 = {
  class: "ba-product-info-block state",
  id: "amazon-status-sb"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text",
  style: {
    "font-weight": "700"
  }
}, " Campaign(s) Status ", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Live state of the campaign on Amazon Advertising ", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-product-info-groups"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "ba-column-title ba-text"
}, "Campaign")], -1));
const _hoisted_31 = {
  class: "ba-product-info-prioritized"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-product-info-prioritized-cell ba-column-title ba-text ba-text-center"
}, " Bidding & budget strategy ", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "profit",
  class: "ba-product-info-prioritized-cell ba-column-title ba-text ba-text-right"
}, " Ads Net profit 4W ", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Forecasted 4-week profit based on net ROAS from performance campaigns and last week's spend. ", -1));
const _hoisted_35 = {
  class: "ba-product-data ba-product-data-bottom"
};
const _hoisted_36 = {
  class: "ba-product-data-content"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "margin",
  class: "ba-product-data-margin ba-column-title ba-text ba-text-right"
}, " Avg Products Margin ", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Weighted average margin rate over the last 28 days for this product. ", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "boost",
  class: "ba-product-data-boost ba-column-title ba-text ba-text-right"
}, " Bid Mult. ", -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Multiplier applied to bids to increase exposure and visibility in ads. ", -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "current4w",
  class: "ba-product-data-4w ba-column-title ba-text ba-text-right"
}, " Current - 4W ", -1));
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " 4-week ROAS from performance campaigns, calculated during the last run of the budget algorithm. ", -1));
const _hoisted_43 = {
  class: "ba-right-side"
};
const _hoisted_44 = {
  class: "ba-perfomance ba-perfomance-bottom"
};
const _hoisted_45 = {
  class: "ba-perfomance-content"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "weeklyBudgetPerf",
  class: "ba-weekly ba-column-title ba-text ba-text-center"
}, " Weekly Budget ", -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " 7 times the daily budget allocated for the campaign. ", -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "potentialPerf",
  class: "ba-pot ba-column-title ba-text ba-text-center"
}, " % of max spend pot. ", -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Maximum spend potential, estimated based on last week's daily max spend and time in budget. ", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "vsPerf",
  class: "ba-last ba-column-title ba-text ba-text-right"
}, " vs. last week spend ", -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Difference between the current week's budget allocation and last week's actual spend. ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_calendar_with_arrow_left_icon = _resolveComponent("calendar-with-arrow-left-icon");
  const _component_app_input = _resolveComponent("app-input");
  const _component_app_switch = _resolveComponent("app-switch");
  const _component_amazon_icon = _resolveComponent("amazon-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [$props.still_initializing ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $options.totalBudget,
    full: true,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"]))]), _hoisted_7, _createElementVNode("div", _hoisted_8, [$props.still_initializing ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: "",
    style: {
      "align-self": "center"
    }
  })) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_calendar_with_arrow_left_icon), _createVNode(_component_currency_value, {
    value: $options.totalLastWeekSpend,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_currency_value, {
    value: $options.totalVariation,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false,
    showSign: "",
    class: _normalizeClass(["ba-text", {
      'ba-text-red': $options.totalVariation < 0,
      'ba-text-green': $options.totalVariation > 0
    }])
  }, null, 8, ["value", "currency", "precision", "class"])])]))])])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_app_input, {
    modelValue: $options.localSearch,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.localSearch = $event),
    v2: "",
    prependIcon: "search",
    prependSimple: "",
    version: "ba-search",
    placeholder: "Search..."
  }, null, 8, ["modelValue"])])]), _hoisted_18]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
    class: _normalizeClass(['ba-text', {
      'ba-text-lighter': $props.mode === 'acos'
    }])
  }, " ROAS ", 2), _createVNode(_component_app_switch, {
    modelValue: $options.localMode,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.localMode = $event),
    options: $data.modes,
    between: ""
  }, null, 8, ["modelValue", "options"]), _createElementVNode("div", {
    class: _normalizeClass(['ba-text', {
      'ba-text-lighter': $props.mode === 'roas'
    }])
  }, " ACOS ", 2)])])])]), _hoisted_23]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_amazon_icon), _createVNode(_component_app_popover, {
    target: "amazon-status-sb",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_28, _hoisted_29]),
    _: 1
  })]), _hoisted_30]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _hoisted_33, _createVNode(_component_app_popover, {
    target: "profit",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_34]),
    _: 1
  })]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_hoisted_37, _createVNode(_component_app_popover, {
    target: "margin",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_38]),
    _: 1
  }), _hoisted_39, _createVNode(_component_app_popover, {
    target: "boost",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_40]),
    _: 1
  }), _hoisted_41, _createVNode(_component_app_popover, {
    target: "current4w",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_42]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_hoisted_46, _createVNode(_component_app_popover, {
    target: "weeklyBudgetPerf",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_47]),
    _: 1
  }), _hoisted_48, _createVNode(_component_app_popover, {
    target: "potentialPerf",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_49]),
    _: 1
  }), _hoisted_50, _createVNode(_component_app_popover, {
    target: "vsPerf",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_51]),
    _: 1
  })])])])])]);
}